<template>
  <div
    class="teaser-warning absolute z-10 w-full p-3 font-bold"
    :class="{
      'mb-size-4 rounded-b-lg': isInGrid,
      'container my-size-4 rounded-lg': !isInGrid,
    }"
  >
    <div class="flex items-center">
      <SpriteSymbol name="info" class="mr-size-8 size-4" />
      <span>{{
        $texts('UnpublishedNodeWarning')
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isInGrid?: boolean
}>()
</script>

<style lang="postcss">
.teaser-warning {
  background-color: rgb(var(--bk-theme-yellow-normal));
  color: rgb(var(--bk-theme-yellow-dark));
}
</style>
